import React, { useState } from 'react';
import PageHeader from '../PageHeader';
import Button from '../common/Button';
import AnnouncementModal from '../AnnouncementModal';

const PromotionsTopBar = () => {
  const [showAnnouncementModal, setShowAnnouncementModal] = useState<boolean>(false);

  return (
    <>
      {showAnnouncementModal && (
        <AnnouncementModal
          isEdit={false}
          onSubmit={() => setShowAnnouncementModal(false)}
          onCancel={() => setShowAnnouncementModal(false)}
        />
      )}
      <PageHeader title="PROMOTIONS">
        <Button className="page-header__action-button" onClick={() => setShowAnnouncementModal(true)}>
          ADD PROMOTION
        </Button>
      </PageHeader>
    </>
  );
};

export default PromotionsTopBar;
